import { Component, Input, OnInit } from '@angular/core';
import { Store } from '@ngxs/store';
import { Alert } from 'app/models/dto/alert.model';
import { DismissDealAlert } from 'app/store/deal/deal-alerts/deal-alerts.actions';
import { DealAlertsState } from 'app/store/deal/deal-alerts/deal-alerts.state';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-deal-alerts',
  templateUrl: './deal-alerts.component.html',
  styleUrls: ['./deal-alerts.component.scss'],
  standalone: false
})
export class DealAlertsComponent implements OnInit {

  @Input() dealId: number;

  dealAlerts$: Observable<Alert[]>;

  constructor(private store: Store) { }

  ngOnInit(): void {
    this.dealAlerts$ = this.store.select(DealAlertsState.dealAlerts).pipe(map(filterFn => filterFn(this.dealId)));
  }

  dismissAlert(alert: Alert) {
    this.store.dispatch(new DismissDealAlert(this.dealId, alert));
  }
}
